import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-4 text-center">
      <div className="flex items-center gap-3">
        <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl font-black">
          爆
        </span>
        <span className="text-xl font-black text-foreground-950">爆料网</span>
      </div>
      <p className="mt-8 font-label text-[76px] md:text-[110px] leading-none text-background-300">
        404
      </p>
      <h1 className="mt-2 text-xl md:text-2xl font-black text-foreground-950">
        这条爆料跑丢了
      </h1>
      <p className="mt-3 max-w-[420px] text-sm leading-7 text-foreground-500">
        页面可能已经被删除、改名，或者链接输入有误。回到首页，那里一直有新的内容在更新。
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/category/society"
          className="inline-flex items-center gap-1.5 h-10 px-4 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          浏览社会爆料
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </div>
  );
}